import PropTypes from 'prop-types'

import { CouponLoading } from 'lmcv/components/Coupon'

import * as S from './styled'

function CarouselSkeleton ({ size }) {
  return (
    <S.Carousel>
      {Array(size)
        .fill()
        .map((item, index) => (
          <S.CarouseItem key={`${item}-${index}`}>
            <CouponLoading />
          </S.CarouseItem>
        ))}
    </S.Carousel>
  )
}

CarouselSkeleton.propTypes = {
  size: PropTypes.number
}

CarouselSkeleton.defaultProps = {
  size: 3
}

export default CarouselSkeleton
